module.exports = __webpack_public_path__ + "static/media/nataly.dc7b1423.png";


//////////////////
// WEBPACK FOOTER
// ./src/about-us/img/nataly.png
// module id = 122
// module chunks = 0